// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3954":"8e61a097","7952":"6426a7b8"}[chunkId] + ".chunk.css";
};